// Module
var code = "<div class=\"layout-column layout-fill flex md-padding\">\n    <mn-files ng-if=\"vm.show\" mn-scroll-item=\"files\" root=\"patient\"\n              root-id=\"vm.currentPatient\" class=\"full-height\"\n              context=\"vm.context\" extra-context=\"vm.extraContext\">\n    </mn-files>\n</div>";
// Exports
module.exports = code;